import { FC } from "react";
import i18next from "i18next";
import { useNavigate } from "react-router-dom";
import { Profile } from "@/models/database/profiles/profile.model";
import { Query_Imgix } from "@/api/imgix";
import { Query_shared } from "./../../../api/shared/index";
import { siteRoutes } from "@/routes/siteRoutesList";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import {
  Avatar,
  Box,
  Card,
  Flex,
  Heading,
  Text,
  Button,
  Tooltip,
} from "@radix-ui/themes";

const ProfileGeneralInfo: FC<
  Profile & {
    belongsToCurrUser: boolean;
    isFollowedByCurrentUser: boolean;
    isFriendsOfCurrentUser: boolean;
    isFriendsRequestPending: boolean;
    receivedFriendRequest: boolean;
    isPlaceholder: boolean;
    error?: string;
  }
> = (props): JSX.Element => {
  // const [communityMembersModalOpen, setCommunityMembersModalOpen] =
  //   useState<boolean>(false);
  const navigate = useNavigate();

  if (props.error) {
    //SHOW ERROR UI
    return <span>{props.error}</span>;
  }

  useDocumentTitle(`${props.userName} - Profile`);

  return (
    <>
      <Card size="4" style={{ width: "100%" }}>
        <Flex wrap="wrap" gap="2" align="center" direction="column">
          <Box>
            <Avatar
              src={Query_shared.imageErrorHandler(
                props.profileLogoUrl?.includes("wog.imgix") ||
                  props.profileLogoUrl?.includes("iplay.imgix")
                  ? `${props.profileLogoUrl}?${Query_Imgix.getImgixUrlProps({
                      w: "190",
                      h: "190",
                      fit: "crop",
                    })}`
                  : props.profileLogoUrl,
                false,
                props.isPlaceholder
              )}
              fallback={props.userName.slice(0, 1)}
              radius="full"
              size="9"
            />
          </Box>

          <Box maxWidth="100%">
            <Flex wrap="wrap" gap="2" align="center" direction="column">
              <Box maxWidth="100%">
                {props.userName && (
                  <Tooltip content={props.userName}>
                    <Heading as="h1" mb="0" truncate>
                      {props.userName}
                    </Heading>
                  </Tooltip>
                )}
              </Box>

              {props.fullName && (
                <Text size="2" color="gray">
                  {props.fullName}
                </Text>
              )}

              <Text as="p" mb="3" size="2">
                {props.profileDescription &&
                  props.uid &&
                  props.profileDescription}
              </Text>
            </Flex>
            {/* {brand.hasFeature.friends && (
            <div
              className="card__community"
              onClick={() => {
                if (!isMobile) {
                  setCommunityMembersModalOpen(true);
                }
              }}
            >
              <>
                {props.community &&
                  ["friends", "followers", "following"]
                    .filter((key) =>
                      Object.prototype.hasOwnProperty.call(props.community, key)
                    )
                    .map((key) => {
                      return (
                        <div className={`community__${key}`} key={key}>
                          {isMobile ? (
                            <a
                              onClick={() => {
                                navigate(
                                  `${siteRoutes["profileCommunityAndSlug"]}${
                                    props.slug || ""
                                  } `
                                );
                              }}
                            >
                              <span className="community__amount">
                                {props.community[key].totalNumber}
                              </span>
                              <p className="community__title">
                                {key === "friends" &&
                                  (props.community[key].totalNumber > 1
                                    ? i18next.t(
                                        "profile.community.tabs.friends_plural"
                                      )
                                    : i18next.t(
                                        "profile.community.tabs.friends_singular"
                                      ))}
                                {key === "followers" &&
                                  (props.community[key].totalNumber > 1
                                    ? i18next.t(
                                        "profile.community.tabs.followers_plural"
                                      )
                                    : i18next.t(
                                        "profile.community.tabs.followers_singular"
                                      ))}
                                {key === "following" &&
                                  (props.community[key].totalNumber > 1
                                    ? i18next.t(
                                        "profile.community.tabs.following_plural"
                                      )
                                    : i18next.t(
                                        "profile.community.tabs.following_singular"
                                      ))}
                              </p>
                            </a>
                          ) : (
                            <button
                              type="submit"
                              onClick={() => setCommunityMembersModalOpen(true)}
                            >
                              <span className="community__amount">
                                {props.community[key].totalNumber}
                              </span>
                              <p className="community__title">
                                {key === "friends" &&
                                  (props.community[key].totalNumber > 1
                                    ? i18next.t(
                                        "profile.community.tabs.friends_plural"
                                      )
                                    : i18next.t(
                                        "profile.community.tabs.friends_singular"
                                      ))}
                                {key === "followers" &&
                                  (props.community[key].totalNumber > 1
                                    ? i18next.t(
                                        "profile.community.tabs.followers_plural"
                                      )
                                    : i18next.t(
                                        "profile.community.tabs.followers_singular"
                                      ))}
                                {key === "following" &&
                                  (props.community[key].totalNumber > 1
                                    ? i18next.t(
                                        "profile.community.tabs.following_plural"
                                      )
                                    : i18next.t(
                                        "profile.community.tabs.following_singular"
                                      ))}
                              </p>
                            </button>
                          )}
                        </div>
                      );
                    })}
              </>
            </div>
          )} */}

            <Flex gap="2" align="center" justify="center" direction="column">
              {props.belongsToCurrUser && (
                <Button
                  variant="solid"
                  onClick={() => navigate(siteRoutes["profileSettings"])}
                >
                  {i18next.t("buttons.manage_btn")}
                </Button>
              )}
              {/* <ProfileCommunityActionButtons
                belongsToCurrUser={props.belongsToCurrUser}
                isFollowedByCurrentUser={props.isFollowedByCurrentUser}
                isFriendsOfCurrentUser={props.isFriendsOfCurrentUser}
                isFriendsRequestPending={props.isFriendsRequestPending}
                receivedFriendRequest={props.receivedFriendRequest}
                isPlaceholder={props.isPlaceholder}
                uid={props.uid}
              /> */}
            </Flex>
          </Box>
        </Flex>
      </Card>
    </>
  );
};

export default ProfileGeneralInfo;
